export const parseLS = (item: string, defaultValue: any = undefined) => {
  const LSItem = localStorage.getItem(item) || defaultValue
  return LSItem !== defaultValue ? JSON.parse(LSItem) : LSItem
}

export const clearLS: () => void = () => {
  localStorage.clear()
  document.cookie = 'bbp-cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}
